export default __webpack_public_path__ + "static/media/9947.6be2c9a0.png";